import API from '../../utils/api';
import { setError } from './errors';
import { ENDPOINT_URL, OUTRIGHTS_PAGE_LIMIT } from '../../constants/defaultValues';
import { OUTRIGHTS_CHANGED, OUTRIGHTS_CLEARED, OUTRIGHTS_PAGINATED } from './types';
import { generateQuery } from '../../utils/helpers';
import { useLatestRequest } from '../../utils/network';
import BaseModel from '../../models/BaseModel';
import OutrightModel from '../../models/agent/outright/outright-model';

export const getOutrights =
    (query = {}, { showLoading = true } = {}) =>
    async (dispatch, getStore) => {
        try {
            const store = getStore();
            const { sportRefId, filters } = store.sportEvents;
            const { pageOffset } = query;

            if (showLoading && pageOffset === 0) {
                dispatch({
                    type: OUTRIGHTS_CHANGED,
                    payload: { isFetching: true },
                });
            } else if (pageOffset > 0) {
                dispatch({
                    type: OUTRIGHTS_CHANGED,
                    payload: { isPaginating: true },
                });
            }

            const queryParams = generateQuery(filters);
            const params = {
                sportTypeId: sportRefId,
                pageOffset,
                pageLimit: OUTRIGHTS_PAGE_LIMIT,
                ...queryParams,
                ...query,
            };

            const res = await useLatestRequest('get-outrights', async () => {
                return API.get(`${ENDPOINT_URL}/events/outright`, {
                    params,
                });
            });

            if (!res) return;

            const { info, item } = res.data;

            if (info.success) {
                const outrightEvent = BaseModel.construct(OutrightModel, item);

                const hasNextPage = outrightEvent.seasons.length >= OUTRIGHTS_PAGE_LIMIT;
                const actionType = pageOffset > 0 ? OUTRIGHTS_PAGINATED : OUTRIGHTS_CHANGED;

                dispatch({
                    type: actionType,
                    payload: {
                        ...outrightEvent,
                        isFetching: false,
                        isPaginating: false,
                        hasNextPage,
                        pageOffset: pageOffset + OUTRIGHTS_PAGE_LIMIT,
                    },
                });
            }

            return res;
        } catch (error) {
            if (error.message.cancelled) return;
            console.log({ error });
            let errors;

            if (error?.response?.data?.info?.errors) {
                errors = error.response.data.info.errors;
                dispatch(setError(errors[0]));
            }

            dispatch({
                type: OUTRIGHTS_CHANGED,
                payload: {
                    isFetching: false,
                },
            });
        }
    };

export const setOutrights = payload => ({
    type: OUTRIGHTS_CHANGED,
    payload,
});

export const clearOutrights = () => ({
    type: OUTRIGHTS_CLEARED,
});
